<template>
  <div class="vue-podcast">
    <iframe
      v-if="podigee"
      class="podigee-podcast-player"
      :src="
        'https://cdn.podigee.com/podcast-player/podigee-podcast-player.html?configuration=' +
          podcast +
          '/embed?context=external'
      "
    ></iframe>
    <div v-else v-html="podcast"></div>
  </div>
</template>

<script>
export default {
  props: {
    podcast: String
  },
  computed: {
      podigee() {
            if(this.podcast.includes('podigee')) {
                  return true;
            } else {
                  return false;
            }
      }
  }
};
</script>

<style lang="scss">
.vue-podcast {
  padding: calc(0.5 * var(--lh)) 0;
  // border-bottom: var(--b) solid var(--color);
}
iframe {
  width: 100%;
  display: block;
}
</style>
